import { useState, useEffect } from 'react';
import styles from './css/floordeform.module.css'

export default function Floordeform(props) {
    return (
        <>
        {
            (props.point !== undefined) ?
                <div className={styles.container}>
                    <div className={styles.bar} style={{width:(props.point/1.5*100)+"%"}}></div>
                </div>
            : <div className={styles.nullcontainer}></div>
        }
        </>
    );
}